export default "__VITE_ASSET__10aeeb86__"